import { posterCardHue } from '../functions/posterCardHue.js'

// The PRIMARY ink of a home-board poster's sub-cards — a card title, a row
// name, a legend numeral: text that carries the message, not the aside.
//
// HOME-POSTER-BRAND-1 gave every poster header its binary ink and
// HOME-POSTER-EMPTYSTATE-INK-1 gave every poster BODY secondary the measured
// `inkSoft` step, but the SUB-CARD components mounted inside a poster body
// (YourAgentCard, the shared EmptyProjectCard, the activity heatmap) kept the
// shell's ADAPTIVE NEUTRAL `title` token. On a THEME-INVARIANT poster hue that
// token is wrong in one theme by construction: measured on /w/system/hq —
// YourAgentCard Title 3.12:1 and EmptyProjectCard Title 3.24:1 in LIGHT (near
// black on a saturated hue), the tile Labels down to 1.11:1, and the same sites
// failing the other way round in DARK (agents Caption 4.18, studio Hint 4.04) —
// all under the 4.5:1 AA floor for normal text
// (HOME-POSTER-NEUTRAL-INK-ON-HUE-1).
//
// This resolver returns the poster family's OWN binary ink
// (`homeWidgetHue(posterId).ink` — the `posterAgentsInk`-style semantic token,
// so a branded workspace's poster override still follows), and the adaptive
// `title` token OUTSIDE a poster — so a SHARED card component can adopt it
// without breaking its neutral mounts. Its `inkSoft` sibling is
// `components/HomePosterSoftInk.js`; both share ONE poster lookup
// (`functions/posterCardHue.js`) so they can never drift.
//
// The component carries `color` and NOTHING else on purpose: a site adds
// `extends: 'HomePosterInk'` (or, from a page that already imports it,
// `color: HomePosterInk.color`) to a leaf that already owns its tag, size,
// weight and layout — only the ink comes from here.
export const HomePosterInk = {
  color: (el) => {
    const h = posterCardHue(el)
    return h ? h.ink : 'title'
  }
}
